module.exports = __webpack_public_path__ + "img/lunbo151.cea67e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo151.png
// module id = QmcI
// module chunks = 0